import {room,CONV_STORAGE, Video, isElectron, animatedLayers, isJoined, permissions} from './roomnew';
import moment from 'moment';
export default class Socket {
constructor(){
    this.connection = null;
    this.host = socketConf.url;
    this.connected = false;
    this.tries = 0;
    this.maxRetry = 2;
    this.retryInterval = 2000;
    this.retryTimeout = 0;
    this.events = {
        roomJoin: false,
        RoomJoinRequest: false,
        RoomJoinResponse: false,
        RoomLeft: false,
        FocusSignal: false,
        unFocusSignal: false,
        RaiseHand: false,
        OutOfKino: false,
        MakeModeratorEVT: false,
        RemoveModeratorEVT: false,
        lowVolume: false,
        maxVolume: false,
        setVolume: false,
        lowVolumeInit: false,
        connectionError: false,
        connectionSuccess: false,
        StreamDropError: false,
        UserJoin: false,
        UserReconnect: false,
        reconnectFailed: false,
        startedRecording: false,
        stoppedRecording: false,
        updateLayers: false,
        ConversationLeft: false,
        ConversationJoined: false,
        conversationNameChanged: false,
        participantPingBack: false,
        conversationJoinInvite: false,
        conversationJoinInviteResponse: false,
        sharingScreen: false,
        chatMessage:false,
        inviteCanceled:false,
        hoursLimitReached:false,
        kinoEndWarning:false,
        myVideoRemoved:false,
        userDropped:false,
        connectedConfirmation:false,
        ConversationLeave:false,
        ConversationUnpin:false,
        NewPinnedConversation:false,
        announcementStart:false,
        announcementStop:false,
        moderatorResponse:false,
        StealFocus:false,
        outOfConversation:false,
        splitConversationInvite:false,
        throwDisconnectMessage:false,
        clientPong:false,
        lobbyOnConnection:false
    };
    this.noConnectionBadge=$("<div/>",{
        class:""
    });
    this.throwErrorTimeout=0;
    this.retryAfterClose=true;
    this.socketId='';
    this.receivedMsgIds=[];
    this.keepAliveInterval=10000;
    this.keepAliveTimeout=0;
    this.allowedEventBeforeJoin=[
        'RoomJoinRequest',
        'moderatorResponse',
        'moderatorRequests',
        'requestCanceled',
        'lobbyOnConnection',
        'setVolume',
        'RoomJoinResponse',
        'ModeratorsAvailable',
        'OutOfKino'
    ];
}


  init(reconnect = false, params = "") {
        var s = this;
        if(s.connected){
            console.log("Socket already connected...");
            return;
        }
        //$("#socketDisconnect").html("Retrying #"+s.tries);
        console.log(`Connecting to: ${socketConf.protocol}://${s.host}:${socketConf.port}${isElectron ? '/'+ROOM_NAME : window.location.pathname}?reconnect=${reconnect}${params} ...`);
        console.time("websocket_connection");//card 798
        // s.connection = new WebSocket(`${socketConf.protocol}://${s.host}:${socketConf.port}${window.location.pathname}?reconnect=${reconnect}${params}`);
        s.connection = io(`${socketConf.protocol}://${s.host}:${socketConf.port}${isElectron ? '/'+ROOM_NAME : window.location.pathname}`,
        {
         transports: ['websocket'],
         upgrade: false,
         reconnectionAttempts: 4,
         randomizationFactor: 0.5,
         reconnectionDelay: 500,
         pingTimeout: 25000,
         pingInterval: 30000,
        });
        s.connection.on("connect",function () {
            console.timeEnd("websocket_connection");//card 798
            console.log("[open] Connection established",s.connection);
            s.socketId=s.connection.id;
            s.connected = true;
            s.retryAfterClose=true;
            clearTimeout(s.retryTimeout);
            //begin card 798
            if(s.events['setPresece']){
                s.events.setPresece();
                s.events.setPresece=undefined;
            }
            if(s.events['lobbyOnConnection']){
                s.events.lobbyOnConnection();
            }
            //end card 798
            if (s.events['connectionSuccess'] !== false) {
                s.events['connectionSuccess'].call(s);
            }
            if(Video){
                animatedLayers.removeLocalConnectionLostLayer();
            }
            clearTimeout(s.throwErrorTimeout);
             if(s.recoverSpacesOnConnect){
                CONV_STORAGE.recoverSpaces();
             }
            s.tries = 0;
            //$("#socketDisconnect").html("Disconnect");

        });

        s.connection.on('message',function (message) {
            try {
                if(!isJoined && !s.allowedEventBeforeJoin.includes(message.eventName)){
                    return;
                }
                // console.warn(`Socket message ${message.eventName}`,message);
                //  console.warn(event.data);
                // let message = message;
                if(message.msgId){
                    if(s.receivedMsgIds.includes(message.msgId)){
                        console.warn("Duplicated message, this message has already been received",message);
                        s.sendConfirm(message.msgId);
                        return
                    }else{
                        s.sendConfirm(message.msgId);
                        s.receivedMsgIds.push(message.msgId);
                    }
                }
                // if(message.eventName=="RaiseHand"){
                //     s.connection.close();
                //     setTimeout(() => {
                //         s.reconnectManually();
                //     }, 5000);
                // }
                if (s.events[message.eventName] !== false) {
                    s.events[message.eventName].call(s, message);
                }
            } catch (e) {
                console.log(e);
            }
        });
        //send ping confirm
        s.connection.on('ping',(msgId)=>{
            s.connection.emit('confirm',msgId);
        });
        s.connection.io.on('reconnect_attempt', (arg) => {
            s.connection.io.opts.query = {
               reconnect:true,
               oldSocketId: s.socketId,
               participant: room ? room.myUserId() : ''
            };
            console.log("Trying reconnecting the socket",arg);
        });

        s.connection.io.on('reconnect', (attempt) => {
            console.log("socket reconnected",attempt);
            try {
                if(!room || !room.myUserId()){
                      //throw error that reconnect failed
                  s.events.reconnectFailed.call(s, "Failed to reconnect you to the kino.");
                  return;
                 }
              } catch (error) {
                  console.error('Reconnect error',error);
              }

            if (typeof CONV_STORAGE !== 'undefined' && room) {
                //reset conversations panel
                //end private space
                if(permissions.canAcceptUsers()){
                    s.moderatorRoom(room.myUserId(),'join')
                }
                CONV_STORAGE.storeLastSpaceId('');
                try {
                    if(CONV_STORAGE.storedState){
                        console.log("Spaces stored state is",CONV_STORAGE.storedState);
                        if(CONV_STORAGE.storedState.private){
                          console.log("Found a private space stored",CONV_STORAGE.storedState.private);
                          CONV_STORAGE.storedState.private.stopSendingStreamsPrivate();
                          setTimeout(() => {
                            CONV_STORAGE.sendPrivacyThumbnail(CONV_STORAGE.storedState.private.id,true);
                          }, 1000);
                        }
                    }
                } catch (error) {
                    console.error("Error restoring private space on reconnect",error);
                }
                CONV_STORAGE.recoverSpaces();
            }
        });
        s.connection.io.on('reconnect_failed', () => {
            console.error("socket reconnect_failed");
            s.events.reconnectFailed.call(s, "Failed to reconnect you to the kino.");
        });

        s.connection.on('disconnect',function (event) {
            s.connected = false;
            s.recoverSpacesOnConnect=false;
            if (event.wasClean) {
                console.log(`[close] Connection closed cleanly, code=${event.code} reason=${event.reason}`);
            } else {
                console.log('[close] Connection died');
            }
            if (s.events['connectionError'] !== false) {
                s.events['connectionError'].call(s, "Connection closed.");
            }
            if(s.events.setPresece){
                s.events.setPresece=undefined;
             }
            return;
            //end card 798

            // if(!s.throwErrorTimeout){
            //     s.throwErrorTimeout=setTimeout(() => {
            //         if(!s.connected){
            //             console.log("After 10 seconds waiting still not connected refresh...");
            //             clearTimeout(s.retryTimeout);
            //             //throw error that reconnect failed
            //             s.events.reconnectFailed.call(s, "Failed to reconnect you to the kino.");
            //         }
            //     }, 10000);
            // }
            // clearTimeout(s.retryTimeout);
            // if (s.tries <= s.maxRetry) {
            //     if(s.tries==0){
            //         s.retryConnect();
            //     }
            //     s.retryTimeout = setTimeout(function () {
            //         s.retryConnect();
            //     }, s.retryInterval);
            // } else {
            //     //throw error that reconnect failed
            //     s.events.reconnectFailed.call(s, "Failed to reconnect you to the kino.");
            // }
        });

        // s.connection.onerror = function (error) {
        //     s.connected = false;
        //     console.log(`[error] ${error.message}`);
        //     if (s.events['connectionError'] !== false) {
        //         s.events['connectionError'].call(s, "Error connecting to the socket.");
        //     }

        // };


    };

    reconnectManually(){
        this.connection.io.opts.query = {
            reconnect:true,
            oldSocketId: this.socketId,
            participant: room ? room.myUserId() : ''
         };
        this.connection.open();
        this.recoverSpacesOnConnect=true;
    };

    addDisconnectBadge(){
        let s=this;
        let disconnectSeconds=[1,3,6,8,10,12];
        let buttons=[];
        disconnectSeconds.forEach(second => {
            buttons.push($("<button/>",{
                class:"btn btn-sm kino-btn-primary",
                html: `${second}s`
            }).on('click',e=>{
                s.retryInterval=second*1000;
                s.connection.disconnect();
            }));
        });
        let buttonsCont=$("<div/>",{
            class:"socket-disconnect-buttons",
            html:buttons
        })
        let disconnectBadge=$("<div/>",{
            class:"socket-diconnect-badge",
            html:[`<span>Disconnect socket for:</span>`,buttonsCont]
        });

        $("body").append(disconnectBadge);
    };
    retryConnect(){
        var s=this;
        s.tries++;
        s.connection = null;
        let params = "";
        if (room) {
             params = `&participant=${room.myUserId()}&room_id=${room.getName()}`;
        }
        console.log("Reconnecting after "+s.retryInterval+" miliseconds for "+s.tries+" time.");
        s.init(true, params);
    };

    sendRoomJoinRequest(data) {
        var s = this;
        console.log("sending join request");
        try {
            if (s.connected) {
                let message = {
                    eventName: "RoomJoinRequest",
                    data: data
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }


    };

    sendJoinAccept(data) {
        var s = this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "RoomJoinResponse",
                    data: {
                        answer: 'accepted',
                        guestId: data.guestId,
                        room_id: data.room_id,
                        resourceId:data.resourceId,
                        guest_user_id: data.user_id,
                        user_id: USER_ID
                    }
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }


    };

    sendStreamDrop(participant) {
        var s = this;
        if (s.connected) {
            try {
                let room_id = room.getName();
                let data = {
                    eventName: "StreamDropError",
                    data: {
                        room_id: room_id,
                        participantId: participant
                    }
                };
                s.connection.send(JSON.stringify(data));
            } catch (e) {
                console.log(e);
            }
        }
    };

    sendJoinRefused(data) {
        var s = this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "RoomJoinResponse",
                    data: {
                        answer: 'refused',
                        guestId: data.guestId,
                        guest_user_id: data.user_id,
                        room_id: data.room_id,
                        resourceId:data.resourceId
                    }
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }


    };

    //begin card 529
    sendFocusSignal(participant, type = "private",silently=false) {
        var s = this;
        if (s.connected) {
            try {
                let myid = room.myUserId();
                let room_id = room.getName();
                let data = {
                    eventName: "FocusSignal",
                    data: {
                        room_id: room_id,
                        participantId: myid,
                        focusOn: participant,
                        type: type,
                        silently:silently,
                        space_id:CONV_STORAGE.myConversation
                    }
                };
                s.connection.send(JSON.stringify(data));
            } catch (e) {
                console.log(e);

            }
        }


    };
    sendFocusConversation(participants, id = 0,token=null) {
        var s = this;
        if (s.connected) {
            try {
                let myid = room.myUserId();
                let room_id = room.getName();
                let data = {
                    eventName: "focusConversation",
                    data: {
                        participants: participants,
                        room_id: room_id,
                        participant: myid,
                        conversation_id: id,
                        token:token
                    }
                };
                s.connection.send(JSON.stringify(data));
            } catch (e) {
                console.log(e);

            }
        }


    };
//end card 529
    sendPublicRaiseHand() {
        var s = this;
        if (s.connected) {
            try {
                let myid = room.myUserId();
                let room_id = room.getName();
                let data = {
                    eventName: "RaiseHand",
                    data: {
                        room_id: room_id,
                        participantId: myid,
                        displayName: MY_NAME
                    }
                };
                s.connection.send(JSON.stringify(data));
            } catch (e) {
                console.log(e);

            }
        }


    };
    // participants array
    sendPrivateRaiseHand(participants) {
        var s = this;
        if (s.connected) {
            try {
                let myid = room.myUserId();
                let room_id = room.getName();
                let data = {
                    eventName: "RaiseHand",
                    data: {
                        room_id: room_id,
                        participantId: myid,
                        displayName: MY_NAME,
                        toParticipant: participants
                    }
                };
                s.connection.send(JSON.stringify(data));
            } catch (e) {
                console.log(e);

            }
        }


    };
    sendOutOfKino(participant) {
        var s = this;
        if (s.connected) {
            try {
                let room_id = room.getName();
                let data = {
                    eventName: "OutOfKino",
                    data: {
                        room_id: room_id,
                        participantId: participant
                    }
                };
                s.connection.send(JSON.stringify(data));
            } catch (e) {
                console.log(e);

            }
        }
    };

    transferModeratorRole(participant) {
        var s = this;
        if (s.connected) {
            try {
                let room_id = room.getName();
                let data = {
                    eventName: "MakeModeratorEVT",
                    data: {
                        room_id: room_id,
                        participantId: participant
                    }
                };
                s.connection.send(JSON.stringify(data));
            } catch (error) {

            }
        }
    };
    moderatorRoom(pid,action){
        var s = this;
        if (s.connected) {
            try {
                let data = {
                    eventName: "ModeratorRoom",
                    data: {
                        action: action,
                        moderator_id: pid
                    }
                };
                s.connection.send(JSON.stringify(data));
            } catch (error) {

            }
        }
    };

    requestsRoom(action){
        var s = this;
        if (s.connected) {
            try {
                let data = {
                    eventName: "RequestsRoom",
                    action: action
                };
                s.connection.send(JSON.stringify(data));
            } catch (error) {

            }
        }
    };

    close() {
        var s = this;
        s.retryAfterClose=false;
        s.connection.disconnect();
        s.connected = false;
    };

    sendUnFocusSignal(participant,buttonPress=true,space_id='',silently=false) {
        var s = this;
        if (s.connected) {
            try {
                let myid = room.myUserId();
                let room_id = room.getName();
                let data = {
                    eventName: "unFocusSignal",
                    data: {
                        room_id: room_id,
                        participantId: myid,
                        focusOn: participant,
                        buttonPress:buttonPress,
                        space_id: !space_id ? CONV_STORAGE.myConversation : space_id,
                        silently:silently
                    }
                };
                s.connection.send(JSON.stringify(data));
            } catch (e) {
                console.log(e);

            }
        }


    };

    sendRoomPresence(data) {
        var s = this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "RoomPresence",
                    data: data
                };
                let parsedMessage = JSON.stringify(message);
                console.log("Sending presence",message);//card 798
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }


    };

    sendStartRecording(msg, forced) {
        var s = this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "startedRecording",
                    data: {
                        name: `${MY_NAME} `,
                        message: msg,
                        participant: room.myUserId(),
                        room_id: room.getName(),
                        forced: forced
                    }
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }
    };

    sendStoppedRecording(msg, forced) {
        var s = this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "stoppedRecording",
                    data: {
                        name: `${MY_NAME} `,
                        message: msg,
                        participant: room.myUserId(),
                        room_id: room.getName(),
                        forced: forced
                    }
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }
    };

    sendConversationNameChanged(cid, room_id, name) {
        let s = this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "conversationNameChanged",
                    data: {
                        participant: room.myUserId(),
                        room_id: room_id,
                        conversation_id: cid,
                        name: name
                    }
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }
    };

    sendParticipantPing(participant) {
        let s = this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "participantPing",
                    data: {
                        ping_from: room.myUserId(),
                        participant: participant,
                        room_id: room.getName()
                    }
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }
    };
    sendConfirmConnected(participant) {
        let s = this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "ConfirmConnected",
                    data: {
                        ping_from: room.myUserId(),
                        participant: participant,
                        room_id: room.getName()
                    }
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }
    };
    sendConversationJoinInvite(participant, conversation_id, is_new = true) {
        let s = this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "conversationJoinInvite",
                    data: {
                        from: room.myUserId(),
                        displayName: MY_NAME,
                        participant: participant,
                        room_id: room.getName(),
                        conversation_id: conversation_id,
                        is_new: is_new
                    }
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }
    };

    sendConversationJoinInviteResponse(data, response) {
        let s = this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "conversationJoinInviteResponse",
                    data: {
                        from: data.from,
                        displayName: MY_NAME,
                        participant: data.participant,
                        room_id: data.room_id,
                        conversation_id: data.conversation_id,
                        response: response
                    }
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }
    };
    /**
     * Screen sharing event
     */
    sendSharingScreen(status) {
        let s = this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "sharingScreen",
                    data: {
                        participant: room.myUserId(),
                        room_id: room.getName(),
                        status: status
                    }
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }
    };

    sendInviteCanceled(){
        let s = this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "inviteCanceled",
                    data: {
                        participant: room.myUserId(),
                        room_id: room.getName()
                    }
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }
    };

    sendConversationLeave(conversation) {
        let s = this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "ConversationLeave",
                    data: {
                        conversation_id: conversation,
                        participant: room.myUserId(),
                        room_id: room.getName()
                    }
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }
    };

        //pullfocus
    sendOutOfConversation(toParticipant){
        let s=this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "outOfConversation",
                    data: {
                        toParticipant: toParticipant,
                        room_id: room.getName()
                    }
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }
    };
sendSplitToConversationsMessage(data,type,lockFocus, masterVolume=0.05, showNotification, playNotificationSound,extradata={}){
    let s=this;
        try {
            if (s.connected) {
                let message = {
                    eventName: "splitToConversations",
                    data: {
                        convos: data,
                        inviteType:type,
                        room_id: room.getName(),
                        from:room.myUserId(),
                        fromName: MY_NAME,
                        lockFocus: lockFocus,
                        masterVolume:masterVolume,
                        showNotification: showNotification,
                        playNotificationSound: playNotificationSound,
                        data:extradata
                    }
                };
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
            }
        } catch (e) {
            console.log(e);
        }
};
sendSplitOutOfSpace(participants,type,lockFocus,masterVolume=0.05,splitType="", showNotification=false, playNotificationSound=false,extradata={}){
    let s=this;
    try {
        if (s.connected) {
            let message = {
                eventName: "splitOutOfSpace",
                data: {
                    participants:participants,
                    inviteType: type,
                    room_id: room.getName(),
                    from: room.myUserId(),
                    fromName: MY_NAME,
                    lockFocus: lockFocus,
                    masterVolume:masterVolume,
                    splitType:splitType,
                    showNotification: showNotification,
                    playNotificationSound: playNotificationSound,
                    data:extradata
                }
            };
            let parsedMessage = JSON.stringify(message);
            s.connection.send(parsedMessage);
        }
    } catch (e) {
        console.log(e);
    }
};
sendYouAreGhost(participant) {
    var s = this;
    if (s.connected) {
        try {
            let room_id = room.getName();
            let data = {
                eventName: "YouAreGhost",
                data: {
                    room_id: room_id,
                    participantId: participant
                }
            };
            s.connection.send(JSON.stringify(data));
        } catch (e) {
            console.log(e);
        }
    }
};
sendBroadcastMessage(data){
    let s = this;
    try {
        if (s.connected) {
            data['room_id']=room.getName();
            let message = {
                eventName: "BroadcastMessage",
                data: data
            };
            let parsedMessage = JSON.stringify(message);
            s.connection.send(parsedMessage);
        }
    } catch (e) {
        console.log(e);
    }
};

sendParticipantLeft(participant) {
    var s = this;
    if (s.connected) {
        try {
            let room_id = room.getName();
            let data = {
                eventName: "participantLeftKino",
                data: {
                    room_id: room_id,
                    participant: participant
                }
            };
            s.connection.send(JSON.stringify(data));
        } catch (e) {
            console.log(e);
        }
    }
};
cancelJoinRequest(roomName){
    let s = this;
    try {
        if (s.connected) {
            let message = {
                eventName: 'cancelJoinRequest',
                data: {
                    room_id: roomName
                }
            }
            let parsedMessage = JSON.stringify(message);
            s.connection.send(parsedMessage);
        }
    } catch(e){
        console.log(e);
    }
}

sendSpacesLockMessage(locked,silent){
     let s = this;
    try {
        let message = {
            eventName: 'SpacesLock',
            data: {
                isLocked: locked,
                silent: silent,
                from: room.myUserId(),
                from_name: MY_NAME
            }
        }
        s.connection.emit('message',message);
    } catch(e){
        console.log(e);
    }
}

sendLockChatter(silent){
    try {
        let message = {
            eventName: 'disableMasterVolume',
            data: {
                unlockMasterVolume: false,
                from: room.myUserId(),
                silent: silent
            }
        };
        this.connection.emit('message',message);
    } catch(e){
        console.log(e);
    }

}

sendUnlockChatter(silent){
    try {
        let message = {
            eventName: 'enableMasterVolume',
            data: {
                unlockMasterVolume: true,
                from: room.myUserId(),
                silent: silent
            }
        };
        this.connection.emit('message',message);
    } catch(e){
        console.log(e);
    }
}
getServerTime(){
    let s = this;
    // console.trace("get server time function called");
    let start=performance.now();
    return new Promise((resolve,reject)=>{
        try {
            if (s.connected) {
                let resolved=false;
                s.events.onServerTime=(msg)=>{
                    // console.log('Server time is',msg.time);
                    // console.log(`server time request took ${performance.now() - start}ms`);
                    // console.log(`Server time in JS is ${moment.utc(msg.time)}`)
                    resolved=true;
                    resolve(msg.time);
                };
                let message = {
                    eventName: 'serverTime',
                    data: {
                        room_id: ROOM_NAME
                    }
                }
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
                setTimeout(() => {
                   if(!resolved){
                      resolve(false);
                   }
                }, 1000);
            }else{
                resolve(false)
            }
        } catch(e){
            resolve(false);
        }
    })

}

getSecondsTodate(serverTime){
    let s = this;
    let start=performance.now();
    return new Promise((resolve,reject)=>{
        try {
            if (s.connected) {
                let resolved=false;
                s.events.onSecondsLeft=(msg)=>{
                    // console.log('Server seconds left is',msg.seconds);
                    // console.log(`server seconds left request took ${performance.now() - start}ms`);
                    resolved=true;
                    resolve(msg.seconds);
                };
                let message = {
                    eventName: 'secondsToTime',
                    data: {
                        endTime:serverTime,
                        room_id: ROOM_NAME
                    }
                }
                let parsedMessage = JSON.stringify(message);
                s.connection.send(parsedMessage);
                setTimeout(() => {
                    if(!resolved){
                       resolve(false);
                    }
                 }, 1000);
            }else{
                resolve(false)
            }
        } catch(e){
            resolve(false);
        }
    })
};


ping(){
    try {
        this.connection.send(JSON.stringify({eventName:"serverPing"}));
    } catch (error) {

    }
};
keepAliveFailed(){
    console.log("keep alive ping timed out");
    this.stopKeepAlive();
};
startKeepAlive(){
    console.log("starting socket keep alive");
    clearInterval(this.keepAliveInterval);
    clearTimeout(this.keepAliveTimeout);
    this.keepAliveInterval=setInterval(()=>{
        this.ping();
        this.keepAliveTimeout=setTimeout(this.keepAliveFailed.bind(this), 10000);
    },10000);
    this.events.clientPong=(message)=>{
        clearTimeout(this.keepAliveTimeout);
    };
};
stopKeepAlive(){
    try {
        clearInterval(this.keepAliveInterval);
        clearTimeout(this.keepAliveTimeout);
    } catch (error) {

    }
};

spaceJoinedMessage(id,token=false){
    return new Promise((resolve,reject)=>{
        try {
        let message = {
                eventName: 'SpaceJoined',
                id:id,
                pid:room.myUserId(),
                token:token
            };
            // let parsedMessage = JSON.stringify(message);
            this.connection.emit('message',message);
            resolve(true)
        } catch (error) {
            reject(error);
            console.error("spaceJoinedMessage error",error);
        }
    });
};
spaceLeftMessage(id,silently=false){
    return new Promise((resolve,reject)=>{
        try {
        let message = {
                eventName: 'SpaceLeft',
                id:id,
                pid:room.myUserId(),
                silently:silently
            };
            // let parsedMessage = JSON.stringify(message);
            this.connection.emit('message',message);
            resolve(true);
        } catch (error) {
            reject(error);
            console.error("spaceLeftMessage error",error);
        }
    });
};

sendConfirm(msgId){
    try {
        this.connection.emit('confirm',msgId);
    } catch (error) {
        console.error("sendConfirm error",error);
    }
}
sendUserRefreshed(old_id,new_id){
    try {
        this.connection.emit('message',{
            eventName: 'UserRefreshed',
            data:{
                old_id:old_id,
                new_id:new_id
            }
        });
    } catch (error) {
        console.error("sendUserRefreshed error",error);
    }
}

emit(data){
    try {
        this.connection.emit('message',data);
    } catch (error) {
        console.error("sendUserRefreshed error",error);
    }
};

sendRawMessage(data){
    try {
        this.connection.emit('message',data);
    } catch (error) {
        console.error("sendUserRefreshed error",error);
    }
};
sendSwitchSessionMessage(token){
    return new Promise((resolve,reject)=>{
        try {
        let timeoutMessage = 0;
        let message = {
                eventName: 'SwitchSession',
                token:token
            };
            // let parsedMessage = JSON.stringify(message);
            timeoutMessage = setTimeout(()=>{
                reject('Request timed out.');
            },5000);

            const onSuccess=(data)=>{
                clearTimeout(timeoutMessage);
                this.connection.off('SessionSwitchStatus',onSuccess);
                if(data.status == "OK"){
                    resolve(true)
                }else if(data.status == "ERR"){
                    reject(data.message);
                }
            }
            this.connection.once('SessionSwitchStatus',onSuccess);
            this.connection.emit('message',message);
        } catch (error) {
            reject(error);
            console.error("spaceJoinedMessage error",error);
        }
    });
};

sendTerminateSession(reason){
    try {
        this.connection.emit('message',{
            eventName: 'TerminateSession',
            reason:reason
        });
    } catch (error) {
        console.error("sendUserRefreshed error",error);
    }
}

};
